import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { PersonIcon } from '@emburse/embark-icons';
import { SelectionModal } from '../../components';
import { $t, useTranslation } from '../../hooks/useTranslation';
function DelegateUserModal({ isOpen, onClose }) {
    useTranslation();
    const [userList, setUserList] = useState([]);
    const onCloseHandler = () => {
        onClose(false);
    };
    const onSelectionHandler = (item) => {
        window.location.href = item.Url;
    };
    const allUsers = useCallback(() => {
        const accountConfig = JSON.parse(JSON.stringify(window.AccountConfig));
        let users = accountConfig.EmpDelegateList ? accountConfig.EmpDelegateList : [];
        users = users.map((user) => ({
            Label: `${user.Name} (${user.Email})`,
            Email: user.Email,
            Url: `ChangeUser.aspx?UID=${user.ID}`,
            ID: user.ID
        }));
        if (accountConfig.OriginalEmp) {
            users.unshift({
                Label: `${accountConfig.OriginalEmp?.FullName} (${accountConfig.OriginalEmp?.Email})`,
                Email: accountConfig.OriginalEmp?.Email,
                Url: `ChangeUser.aspx?UID=${accountConfig.OriginalEmp?.ID}`,
                ID: accountConfig.OriginalEmp?.ID
            });
        }
        return users;
    }, []);
    useEffect(() => {
        if (isOpen && userList.length === 0) {
            setUserList(allUsers());
        }
    }, [isOpen, userList, allUsers]);
    return (_jsx(SelectionModal, { title: $t('All Delegates'), items: userList, showFilter: true, listTitle: `Certify ${$t('Accounts')}`, listIcon: PersonIcon, selectedItem: window.AccountConfig.Emp.FullName, selectedCaption: $t('Currently logged in'), error: "", isOpen: isOpen, onSelection: onSelectionHandler, onClose: onCloseHandler }));
}
export default DelegateUserModal;
